import * as React from 'react';

import { decorateEditorialHtml } from 'utils/editorial-utils';

interface FormattedParagraphProps {
  text?: string; // HTML raw string to format
  formatter?: (text?: string) => { __html: string }; // Formatter custom function
}

export const FormattedParagraph: React.FC<FormattedParagraphProps> = ({ text, formatter }: FormattedParagraphProps) => {
  if (text) {
    return <section dangerouslySetInnerHTML={formatter(text)} className="uitk-type-paragraph-300 all-t-margin-two" />;
  }

  return null;
};

FormattedParagraph.defaultProps = {
  formatter: decorateEditorialHtml
};

FormattedParagraph.displayName = 'FormattedParagraph';
